import _ from 'underscore';
import Promise from 'bluebird';
import { FileUtils } from '@bingads-webui-clientcenter/common-utils';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { useValidationContext } from '../validation-context';
import { useDataManagement, useErrorHandler } from '../../hooks';
import { skipValidationResult } from '../../constants';
import { isIndianAddress } from '../../utils';

const { containsFile } = FileUtils;
const { ErrorCode: { GstInNumberAddressNotMatch } } = Constants;

export const TaxValidation = () => {
  const {
    i18n,
    accountId,
    getAblInfoData,
    dataManagement,
    notificationApi,
    onContinue,
    onCancel,
  } = useValidationContext();

  const { addressData: { address }, taxData, businessNameData } = getAblInfoData();
  const { data: taxInfo, taxCertification: taxCertificate } = taxData || {};
  const isIndianAddressForEInvoicing = isIndianAddress(address);

  const verifyTaxInformation = jsData => Promise.all([
    (!_.isEmpty(taxInfo)
      ? jsData.VerifyTaxInformation.create({
        accountId,
        address: {
          ...address,
          BusinessName: businessNameData.businessName,
        },
        taxInfo,
        taxCertificate,
      }, {
        useFormDataFormat: containsFile(taxCertificate && taxCertificate.TaxCertifications),
      })
      : Promise.resolve(skipValidationResult)),
    (isIndianAddressForEInvoicing
      ? jsData.IndiaEInvoicingGenerationValidation.create({
        address: {
          ...address,
          BusinessName: businessNameData.businessName,
        },
        taxInfo,
      })
      : Promise.resolve(skipValidationResult)),
  ]);

  const { data: taxInformationValidationResult, error, loading } = useDataManagement({
    dataFetch: verifyTaxInformation,
    ...dataManagement.verifyTaxInformation,
  }, []);

  const onSuccess = ({ data }) => {
    if (isIndianAddressForEInvoicing && _.isArray(data) && data.length === 2) {
      if (!_.get(data[1], 'isValid')) {
        if (_.get(data[1], 'errorCode') === GstInNumberAddressNotMatch && _.isFunction(_.get(notificationApi, 'showWarning'))) {
          notificationApi.showWarning(i18n.getString(_TL_('The GSTIN you entered doesn’t match the business location on your registration. Please check your GSTIN and try again.')));
          onCancel();
          return;
        }
      }
    }
    onContinue();
  };

  useErrorHandler({
    data: taxInformationValidationResult,
    error,
    loading,
    notificationApi,
    errorCallback: onCancel,
    successCallback: onSuccess,
  });

  return null;
};
